import { useState } from "react";
import { supabase } from "../supabase";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BottomSheet from "../components/BottomSheet";

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [sheetOpen, setSheetOpen] = useState(false);
  const [sheetTab, setSheetTab] = useState('company');

  const handleKakaoLogin = async () => {
    setLoading(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'kakao',
      options: {
        redirectTo: window.location.origin,
        queryParams: { prompt: 'login' },
      },
    });
    if (error) {
      alert('로그인 중 오류가 났어요. 다시 시도해주세요.');
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setLoadingGoogle(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin,
      },
    });
    if (error) {
      alert('로그인 중 오류가 났어요. 다시 시도해주세요.');
      setLoadingGoogle(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f0f0f0', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 430, background: '#ffffff', minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: "'DM Mono', monospace" }}>

        <Header variant="login" />

        <div style={{ padding: '20px 16px', display: 'flex', flexDirection: 'column', gap: 12, flex: 1, animation: 'fadeInUp .3s ease' }}>
          <div style={{ border: '1px solid #111111', borderRadius: 12, overflow: 'hidden', padding: '14px', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
            <span style={{ fontSize: 22, flexShrink: 0, lineHeight: 1 }}>💬</span>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#111111' }}>로그인하면 말풍선 3개 무료!</div>
              <div style={{ fontSize: 13, color: '#555555', lineHeight: 1.6 }}>
                지금 가입하면 <strong>말풍선 3개</strong>를 바로 드려요.<br />말풍선 1개 = 변환 1회
              </div>
            </div>
          </div>

          <div style={{ border: '1px solid #111111', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ background: '#111111', color: '#ffffff', padding: '10px 14px', fontSize: 16, fontWeight: 700, letterSpacing: 1, textAlign: 'center' }}>
              로그인 / 회원가입
            </div>
            <div style={{ padding: '20px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>

              <button onClick={handleKakaoLogin} disabled={loading}
                style={{ width: '100%', background: '#FEE500', color: '#111111', border: '1px solid #111111', borderRadius: 12, overflow: 'hidden', padding: '14px 20px', fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, opacity: loading ? 0.7 : 1, fontFamily: "'DM Mono', monospace" }}>
                {loading ? (
                  <span style={{ width: 18, height: 18, border: '2px solid rgba(0,0,0,0.2)', borderTopColor: '#111111', borderRadius: '50%', display: 'inline-block', animation: 'spin .7s linear infinite' }} />
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M12 3C7.029 3 3 6.14 3 10.007c0 2.469 1.638 4.644 4.116 5.88L6.1 19.36a.25.25 0 0 0 .364.277L10.9 16.9c.361.04.727.062 1.1.062 4.971 0 9-3.141 9-7.007C21 6.14 16.971 3 12 3z" fill="#111111"/>
                  </svg>
                )}
                {loading ? '로그인 중...' : '카카오로 시작하기'}
              </button>

              <button onClick={handleGoogleLogin} disabled={loadingGoogle}
                style={{ width: '100%', background: '#ffffff', color: '#111111', border: '1px solid #111111', borderRadius: 12, overflow: 'hidden', padding: '14px 20px', fontSize: 15, fontWeight: 700, cursor: loadingGoogle ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, opacity: loadingGoogle ? 0.7 : 1, fontFamily: "'DM Mono', monospace" }}>
                {loadingGoogle ? (
                  <span style={{ width: 18, height: 18, border: '2px solid rgba(0,0,0,0.2)', borderTopColor: '#111111', borderRadius: '50%', display: 'inline-block', animation: 'spin .7s linear infinite' }} />
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                  </svg>
                )}
                {loadingGoogle ? '로그인 중...' : '구글로 시작하기'}
              </button>

            </div>
          </div>

          <div style={{ fontSize: 13, color: '#bbbbbb', textAlign: 'center', lineHeight: 1.7 }}>
            로그인 시 이용약관 및 개인정보처리방침에<br />동의한 것으로 간주합니다.
          </div>
        </div>

        <Footer onOpenSheet={(tab) => { setSheetTab(tab); setSheetOpen(true); }} />

      </div>

      {sheetOpen && (
        <BottomSheet
          sheetTab={sheetTab}
          setSheetTab={setSheetTab}
          onClose={() => setSheetOpen(false)}
        />
      )}
    </div>
  );
}